import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppStore } from "../../../../../../../hooks/useStores";
import { ActiveTab } from "../VideoEraserPopup";
import VideoEraserKeyPoints from "./KeyPoints/VideoEraserKeyPoints";
import VideoEraserPrompt from "./Prompt/VideoEraserPrompt";
import VideoEraserMaskUpload from "./Upload/VideoEraserMaskUpload";
import styles from "./VideoEraserPopupConfig.module.scss";

type VideoEraserPopupConfigProps = {
	activeTab: ActiveTab | undefined;
	setActiveTab: (tab: ActiveTab | undefined) => void;
};

const VideoEraserPopupConfig = ({ activeTab, setActiveTab }: VideoEraserPopupConfigProps) => {
	const { t } = useTranslation("video_editing", { keyPrefix: "lab.config.tools.erase.popup.config" });
	const { videoGenerationStore, videoEditingStore } = useAppStore();

	useEffect(() => {
		videoGenerationStore.handleSegmentConfigChange("video", videoEditingStore.config.video);
	}, []);

	return (
		<Box className={styles.container}>
			<Typography className={styles.title}>{t("title")}</Typography>
			<VideoEraserPrompt {...{ activeTab, setActiveTab }} />
			<VideoEraserKeyPoints {...{ activeTab, setActiveTab }} />
			<VideoEraserMaskUpload {...{ activeTab, setActiveTab }} />
		</Box>
	);
};

export default observer(VideoEraserPopupConfig);
